exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ef-page__container[data-v-a9d4fae8] {\r\n  margin-bottom: 4.5rem;\n}\r\n", ""]);

// exports
